import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  CONFIGURATION_ITEM_ACTUAL_START_DATE,
  CONFIGURATION_ITEM_ACTUAL_END_DATE,
  EDIT,
  ADD,
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/modal-summary/ci-unavailability-summary.css';
import { getTimezoneForNetwork } from 'AppSrc/core/utility-functions/date-functions';
import moment from 'moment-timezone';
import { SUMMARY_SECTION_V_F_MODAL } from './modal-summary-constants';

const defaultTimezone = getTimezoneForNetwork('mobile');

const getDateTypeDisplay = (date) => {
  if (!date) { return '-'; }

  const dateMoment = moment.tz(date, defaultTimezone);
  const timeZone = dateMoment.format('z');
  const dateString = dateMoment.format('DD/MM/YYYY HH:mm');
  return `${dateString} (${timeZone} 24hr)`;
};

const getOperationButtonText = (sectionData) => {
  const actualStartDate = sectionData[CONFIGURATION_ITEM_ACTUAL_START_DATE];
  const actualEndDate = sectionData[CONFIGURATION_ITEM_ACTUAL_END_DATE];
  if (!actualEndDate || !actualStartDate) {
    return ADD;
  }
  return EDIT;
};

const CiUnavailabilitySummary = ({
  modalData,
  editItem,
  displayType,
  readOnly,
}) => {
  const { dataByFormSectionId } = modalData;
  const tableData = Object.values(dataByFormSectionId).map((section) => {
    const row = {};
    Object.keys(section.dataByFieldId).forEach((field) => {
      row[field] = section.dataByFieldId[field].value;
    });
    row.id = section.sectionId;
    return row;
  });

  const dataMap = tableData;

  const summaryPageView = displayType === SUMMARY_SECTION_V_F_MODAL;
  // don't render the table in the summary view if there are no items
  if (summaryPageView && dataMap.length === 0) {
    return null;
  }

  return (
    <div className="ci-unavailability-summary ci-unavailability-summary-summary-page vf-table">
      <div className="vf-table-head-container">
        <div
          className="vf-table-head"
        >
          <div className="id id-head head-item">
            <span className="head-text">
              CI ID
            </span>
          </div>

          <div className="name name-head head-item">
            <span className="head-text">
              CI Name
            </span>
          </div>
          <div className="status status-head head-item">
            <span className="head-text">
              Status
            </span>
          </div>
          <div className="start-date start-date-head head-item">
            <span className="head-text">
              Actual Start Date/time
            </span>
          </div>
          <div className="end-date end-date-head head-item">
            <span className="head-text">
              Actual End Date/Time
            </span>
          </div>
          <div className="operation operation-head head-item">
            <span className="head-text" />
          </div>
        </div>
      </div>

      {
        dataMap.map((sectionData) => {
          const { reference_id: referenceId, id } = sectionData;
          const startDateValue = sectionData[CONFIGURATION_ITEM_ACTUAL_START_DATE];
          const endDateValue = sectionData[CONFIGURATION_ITEM_ACTUAL_END_DATE];

          // not all fields have a start and end date
          const formattedStartDate = getDateTypeDisplay(startDateValue);
          const formattedEndDate = getDateTypeDisplay(endDateValue);
          const name = sectionData.name;
          const status = sectionData.status;
          const operation = getOperationButtonText(sectionData);

          return (
            <div
              className="vf-table-row-container"
              key={referenceId}
            >
              <div
                className="vf-table-row"
              >
                <div
                  className="row-with-cols"
                >
                  <div className="id id-row row-item">
                    <span className="row-item-text">
                      {referenceId}
                    </span>
                  </div>
                  <div className="name name-row row-item">
                    <span className="row-item-text" data-tip={name}>
                      {name}
                    </span>
                  </div>
                  <div className="status status-row row-item">
                    <span className="row-item-text">
                      {status}
                    </span>
                  </div>
                  <div className="start-date start-date-row row-item">
                    <span className="row-item-text">
                      {formattedStartDate}
                    </span>
                  </div>
                  <div className="end-date end-date-row row-item">
                    <span className="row-item-text">
                      {formattedEndDate}
                    </span>
                  </div>
                  {
                    !readOnly && (
                      <OptionButton
                        type="button"
                        className="row-button"
                        onClick={editItem}
                        option={id}
                      >
                        <div className="operation operation-row row-item">
                          <span className="row-item-text">
                            {operation}
                          </span>
                        </div>
                      </OptionButton>
                    )
                  }
                </div>
              </div>
            </div>
          );
        })
      }
      <ReactTooltip />
    </div>
  );
};


CiUnavailabilitySummary.propTypes = {
  // formData: formDataShape,
  modalData: formDataShape,
  editItem: PropTypes.func,
  // deleteItem: PropTypes.func,
  displayType: PropTypes.string,
  readOnly: PropTypes.bool,
};

const CI_UNAVAILABILITY_SUMMARY = 'CI_UNAVAILABILITY_SUMMARY';

export {
  CiUnavailabilitySummary,
  CI_UNAVAILABILITY_SUMMARY,
};

